import { Box, Theme } from "@mui/material"
import { IRootState } from "app/model"
import { IAppOverlayMessage } from "message/model"
import React from "react"
import { connect } from "react-redux"
import { LinearLoader } from "ui/components/LinearLoader"

export interface IOverlayMessagesProps {
  messages: IAppOverlayMessage[]
}

const OverlayMessagesFn = React.memo(({ messages }: IOverlayMessagesProps) => {
  if (messages.length === 0) {
    return null
  }
  const lastMessage: IAppOverlayMessage = messages[messages.length - 1]
  return (
    <Box
      sx={{
        "position": "absolute",
        "z-index": 10,
        "width": "100%",
        "height": "100%",
        "display": "flex",
        "alignItems": "center",
        "top": 0,
        "left": 0,
        "justifyContent": "center",
        "backgroundColor": (theme: Theme) => `${theme.palette.background.default}80`,
        "& > *": {
          width: "70%",
          textAlign: "center"
        },
        "& .linear-loader": {
          backgroundColor: (theme: Theme) => theme.palette.background.paper,
          padding: "2rem",
          borderRadius: ".25rem",
          maxWidth: "40rem"
        }
      }}>
      <LinearLoader className="linear-loader" text={lastMessage.text} />
    </Box>
  )
})

export const OverlayMessages = connect(
  (state: IRootState): IOverlayMessagesProps => ({
    messages: state.message.overlayMessages
  })
)(OverlayMessagesFn)
